import TranslateDessert from "@/views/admin/translate/TranslateDessert";

export default {
  path: "translate/dessert",
  name: "TranslateDessert",
  component: TranslateDessert,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
